import { grantsPortalAccess } from '~/utils/contact-portal-access';
export const deleteBlockedTextsPath = 'client.detail.summary.contacts.deleteBlocked';
export const hasPortalAccess = (contact)=>grantsPortalAccess(contact.userId() != null, contact.role());
export const deleteTooltipProps = (eligibility, texts)=>{
    if (eligibility.type === 'eligible') return undefined;
    return {
        title: texts[eligibility.notEligible.reason](),
        placement: 'bottom'
    };
};
